<div class="ca-numeric-stepper-wrapper" [class.ca-stepper-disabled]="disabled()">
    @if (title()) {
        <label class="ca-stepper-label">{{ title() }}</label>
    }
    <div class="ca-numeric-stepper">
        <div class="ca-stepper-item ca-stepper-item-decrement" (click)="step(-1)">
            <ca-icon icon="big-minus" class="ca-icon-s-16-p-0-f-16"></ca-icon>
        </div>
        @if (numericMask()) {
            <input
                [formControl]="control()"
                class="ca-stepper-item-value"
                [step]="numericStep()"
                [min]="numericMin()"
                [max]="numericMax()"
                [mask]="numericMask()?.pattern"
                [patterns]="numericMask()?.customPatterns!"
                [decimalMarker]="numericMask()?.decimalMarker!"
                [separatorLimit]="numericMask()?.separatorLimit!"
                [dropSpecialCharacters]="numericMask()?.dropSpecialCharacters!"
                [suffix]="numericMask()?.suffix!"
                [prefix]="numericMask()?.prefix!"
                (input)="onInputChange($event)"
            />
        } @else {
            <input
                [formControl]="control()"
                class="ca-stepper-item-value"
                [step]="numericStep()"
                [min]="numericMin()"
                [max]="numericMax()"
                (input)="onInputChange($event)"
            />
        }
        <div class="ca-stepper-item ca-stepper-item-increment" (click)="step(1)">
            <ca-icon icon="big-plus" class="ca-icon-s-16-p-0-f-16"></ca-icon>
        </div>
    </div>
    <ng-content select="[stepper-error]"></ng-content>
</div>
